export const TWO_FACTOR = {
  OPEN: 'TWO_FACTOR_OPEN',
  CLOSE: 'TWO_FACTOR_CLOSE',
  SUBMIT: 'TWO_FACTOR_SUBMIT',
};

export const openTwoFactor = payload => ({
  type: TWO_FACTOR.OPEN,
  payload,
});

export const closeTwoFactor = () => ({
  type: TWO_FACTOR.CLOSE,
});

export const submitTwoFactor = payload => {
  return {
    type: TWO_FACTOR.SUBMIT,
    payload,
  };
};
